var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0066d0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M473.47,188.69c7.1.55,14.21,1.09,21.31,1.67,4.91.4,9.81.87,14.84,1.32v67.22c-2.02,0-3.9-.02-5.77,0-14.17.21-28.36-.02-42.5.75-17.58.95-27.33,10.24-28.12,27.79-.82,18.39-.18,36.85-.18,55.9h74.09c-3.28,25.42-6.47,50.18-9.72,75.35h-64.55v192.62h-77.67v-192.45h-64.82v-75.22h64.75c0-2.12,0-3.71,0-5.31.08-19.68-.41-39.39.4-59.04.97-23.7,7.97-45.43,24.68-63.14,12.71-13.47,28.57-21.18,46.51-24.89,4.81-1,9.68-1.72,14.53-2.56,10.74,0,21.48,0,32.22,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.272c35e5a25c3b2c37db68f6f4133677.svg";
export { ForwardRef as ReactComponent };